<template>
  <div ref="AboutMeAbstract" class="about-me-abstract transparent">
    <jumbotron
      :title="$t('aboutMe.abstract.title')"
      :paragraph="$t('aboutMe.abstract.description')"
      :position="screenIsLargeOrLarger ? 'right' : 'left'"
      displayImage="/img/jumbotron/me.png"
      displayImageAlt="Marcos Vega"
      color="secondary"
      direction="doubled"
    />
    <h2 class="about-me-abstract-title text-center">{{ $t("aboutMe.abstract.subtitle") }}</h2>
    <p
      v-for="(text, i) in $t('aboutMe.abstract.textes')"
      :key="`about-me-abstract-text${i}`"
      class="about-me-abstract-text text-justify"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
const Jumbotron = () =>
  import(/* webpackChunkName: "JumbotronComponent" */ "@/components/Global/Jumbotron.vue");

export default {
  name: "AboutMeAbstract",
  components: {
    Jumbotron
  },
  computed: {
    /*
     * @computed - screenIsLargeOrLarger
     * TRUE if screen is large or larger width
     */
    screenIsLargeOrLarger() {
      return this.$store.state.Global.window.width >= this.$utils.styles.breakpoints.large;
    }
  }
};
</script>

<style lang="scss" scoped>
.about-me-abstract {
  &-title {
    margin-top: 3rem;
  }

  &-text {
    @include breakpoint($small) {
      font-size: 1.25rem;
    }
  }
}
</style>
